module.exports = __webpack_public_path__ + "static/img/bonus.a8c6af0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/innerMessage/bonus.svg
// module id = v1Ok
// module chunks = 0